export default __webpack_public_path__ + "images/4efb3ee7d0b15dae0515cec42b7fe120-mormonism_small.webp";